import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Component, cloneElement, h } from 'preact';
import { withRouter } from 'react-router';
import { shallowEquals } from 'diskho';
import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';

var PureComponent = function (_Component) {
  _inherits(PureComponent, _Component);

  function PureComponent() {
    _classCallCheck(this, PureComponent);

    return _possibleConstructorReturn(this, (PureComponent.__proto__ || _Object$getPrototypeOf(PureComponent)).apply(this, arguments));
  }

  _createClass(PureComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(props, state) {
      return !shallowEquals(this.props, props) || !shallowEquals(this.state, state);
    }
  }]);

  return PureComponent;
}(Component);

var next = typeof window !== "undefined" && window.requestAnimationFrame ? function (cb, _timeout) {
  return window.requestAnimationFrame(cb);
} : function (cb, timeout) {
  return setTimeout(cb, timeout);
};

/**
 * Lazy-loaded list.
 *
 * NOTE: Should preferably be a homogenous list, `itemComponent` and `dummyComponent`
 *       should return the same components, just intialized differently. If this is
 *       not done the `itemComponent` components may be reinitialized during scroll
 *       and reused with different data, causing unnecessary internal re-renders,
 *       re-flows and component-animations.
 */
var AwesomeList = function (_PureComponent) {
  _inherits(AwesomeList, _PureComponent);

  // Map of index => Element to check for visibility
  function AwesomeList(props) {
    _classCallCheck(this, AwesomeList);

    var _this = _possibleConstructorReturn(this, (AwesomeList.__proto__ || _Object$getPrototypeOf(AwesomeList)).call(this, props));

    _this.onScroll = function () {
      if (!_this.throttle) {
        _this.throttle = next(_this.calculateVisible, _this.props.timeout);
      }
    };

    _this.calculateVisible = function () {
      _this.throttle = null;

      var margin = _this.props.margin;
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      var windowWidth = window.innerWidth || document.documentElement.clientWidth;
      var visible = [];
      var rect = void 0;

      for (var i = 0; i < _this.elements.length; i++) {
        if (!_this.elements[i]) {
          continue;
        }

        rect = _this.elements[i].getBoundingClientRect();

        if (rect.top <= windowHeight + margin && rect.top + rect.height >= -margin && rect.left <= windowWidth + margin && rect.left + rect.width >= -margin) {
          visible.push(i);
        }
      }

      _this.props.onVisible(visible);
    };

    _this.elements = [];
    _this.throttle = null;
    return _this;
  }
  // Throttle identifier, if present we already have queued an instance of `calculateVisible`


  _createClass(AwesomeList, [{
    key: "_mkRegisterCallback",
    value: function _mkRegisterCallback(i) {
      var _this2 = this;

      return function (el) {
        if (el) {
          _this2.elements[i] = el;

          _this2.onScroll();
        } else {
          _this2.elements[i] = null;
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onScroll();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll, { passive: true });
      window.removeEventListener('resize', this.onScroll, { passive: true });
    }
  }, {
    key: "render",
    value: function render(_ref) {
      var component = _ref.component,
          dummyComponent = _ref.dummyComponent,
          itemComponent = _ref.itemComponent,
          pages = _ref.pages,
          totalItems = _ref.totalItems;

      var i = 0;
      var children = [];
      var currentPage = null;
      var pageIdx = 0;

      while (i < totalItems) {
        if (!currentPage && pages[pageIdx] && pages[pageIdx].index === i) {
          currentPage = pages[pageIdx++];
        }

        if (!currentPage) {
          children.push(dummyComponent(i, this._mkRegisterCallback(i)));

          i++;

          continue;
        }

        if (!currentPage.items[i - currentPage.index]) {
          currentPage = null;

          continue;
        }

        children.push(itemComponent(currentPage.items[i - currentPage.index], i, this._mkRegisterCallback(i)));

        i++;
      }

      return cloneElement.apply(null, [component, {}].concat(children));
    }
  }]);

  return AwesomeList;
}(PureComponent);
AwesomeList.defaultProps = {
  timeout: 50,
  margin: 0,
  component: h("div", null)
};

var REGISTER = "store/action_delay/REGISTER";

/**
 * Registers the action `actionType` to be delayed for at least `timeout` milliseconds, it
 * will not delay the internal actions in the action itself or any asynchronous events inside
 * of the action payload itself..
 *
 * This delay happens on its `action.payload` data, replacing it with a Promise delaying the
 * resolve by `timeout` milliseconds counted from when the middleware first encounters the action,
 * before passing it on to the other middlewares and enhancers.
 *
 * The optional `callback` will be called with the store-dispatch function after the delay but
 * before the `action.payload` promise is resolved.
 *
 * NOTE: Does only delay a single instance of the action. If another `setActionDelay` is dispatched
 *       its delay will replace previous dispatches.
 */
var setActionDelay = function setActionDelay(actionType, timeout, callback) {
  return {
    type: REGISTER,
    actionType: actionType,
    timeout: timeout,
    callback: callback
  };
};

/**
 * Middleware delaying select actions using Flux Standard Action protocol (ie. they have a
 * `payload`-property), dispatch `setActionDelay` actions to set which action should be
 * delayed.
 *
 * NOTE: Only allows the delay of one action at a time. Once it encounters a matching action
 *       the internal state will be reset, requiring further calls to `setActionDelay` to
 *       delay multiple instances.
 */
var actionDelayMiddleware = function actionDelayMiddleware() {
  return function (store) {
    var animateNextActionOfType = void 0;
    var animateDelay = void 0;
    var animateCallback = void 0;

    return function (next) {
      return function (action) {
        switch (action.type) {
          case REGISTER:
            

            animateNextActionOfType = action.actionType;
            animateDelay = action.timeout;
            animateCallback = action.callback;

            return;
          case animateNextActionOfType:
            if (action.payload) {
              var payload = action.payload;
              var _timeout = animateDelay;
              var _callback = animateCallback;

              animateNextActionOfType = null;
              animateDelay = null;
              animateCallback = null;

              return next(_extends({}, action, {
                payload: new _Promise(function (resolve, _reject) {
                  return setTimeout(function (_) {
                    if (_callback) {
                      _callback(store.dispatch);
                    }

                    resolve(payload);
                  }, _timeout || 0);
                })
              }));
            }
          // Fallthrough
          default:
            return next(action);
        }
      };
    };
  };
};

/**
 * Guards an event callback against being triggered when alt, ctrl, meta or shift are being held down.
 */
var guardModifiers = function guardModifiers(eventCb) {
  return eventCb ? function (event) {
    return event.altKey || event.ctrlKey || event.metaKey || event.shiftKey ? null : eventCb(event);
  } : null;
};

/**
 * Component which scrolls to top of the window when rendered or the route changes.
 *
 * By default it will only update if the action is PUSH and pathname and/or search differs.
 */

var InnerScrollTop = function (_Component) {
  _inherits(InnerScrollTop, _Component);

  function InnerScrollTop() {
    _classCallCheck(this, InnerScrollTop);

    return _possibleConstructorReturn(this, (InnerScrollTop.__proto__ || _Object$getPrototypeOf(InnerScrollTop)).apply(this, arguments));
  }

  _createClass(InnerScrollTop, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          scrollOnActions = _props.scrollOnActions,
          history = _props.history;


      if (scrollOnActions.indexOf(history.action) !== -1) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          diffPathname = _props2.diffPathname,
          diffSearch = _props2.diffSearch,
          diffHash = _props2.diffHash,
          diffKey = _props2.diffKey,
          scrollOnActions = _props2.scrollOnActions,
          history = _props2.history,
          location = _props2.location;


      var prevLocation = prevProps.location || {};

      if (scrollOnActions.indexOf(history.action) !== -1 && (diffPathname && location.pathname !== prevLocation.pathname || diffSearch && location.search !== prevLocation.search || diffHash && location.hash !== prevLocation.hash || diffKey && location.key !== prevLocation.key)) {
        window.scrollTo(0, 0);
      }
    }
  }]);

  return InnerScrollTop;
}(Component);

InnerScrollTop.defaultProps = {
  scrollOnActions: ["PUSH", "REPLACE"],
  diffPathname: true,
  diffSearch: true,
  diffHash: false,
  diffKey: false
};


var ScrollTop = withRouter(InnerScrollTop);

export { AwesomeList, PureComponent, setActionDelay, actionDelayMiddleware, guardModifiers, ScrollTop };
